import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import Check from '@mui/icons-material/Check'
import type { AssistantToolStep } from './useAssistantChat'

const TOOL_LABELS: Record<string, string> = {
  getSalesPerformance: 'Sales performance',
  getTimesheetExceptions: 'Late and extra hours',
  getBusinessLocations: 'Locations',
  getPopularTrucksSold: 'Trucks sold',
  getSpendByCategory: 'Spend and sales tax',
  getRepairShopRank: 'Repair shops',
  getShippingAudit: 'Shipping',
  getLingeringPendingSales: 'Pending sales',
  getBuyingPatterns: 'What customers are buying',
  getTopInventoryPeople: 'Inventory people',
  getTruckTimeline: 'Truck timeline',
  recommendShopForTruck: 'Shop recommendation',
  searchInventory: 'Inventory',
  searchLeads: 'Leads',
  searchApplications: 'Applications',
  searchExpenses: 'Expenses',
  listRecordPhotos: 'Photos and files',
  getLead: 'Lead',
  getApplicationStatus: 'Application status',
  decodeVin: 'VIN',
  graybookRecommend: 'Gray Book price',
  graybookRecommendMany: 'Gray Book prices',
  findPage: 'Portal pages',
  renderChart: 'Chart',
  renderTable: 'Table',
  renderPortalPreview: 'Preview',
  suggestNext: 'Suggestions',
  getDashboardSnapshot: 'Dashboard',
  listMyDataAccess: 'Access',
  semanticSearch: 'Search',
  remember: 'Remembered notes',
  forget: 'Remembered notes',
  proposeCreateLead: 'Create lead',
  proposeUpdateLeadStatus: 'Lead status',
  proposeUpdateInventoryFields: 'Inventory fields',
  proposeUpdateInventoryStatus: 'Inventory status',
  proposeApplyGraybookPrice: 'Gray Book price',
  proposeNavigate: 'Open page',
  proposeCreateInventoryList: 'Inventory list',
  proposeCreateMarketingCampaign: 'Campaign draft',
  proposeSendMarketingCampaign: 'Send campaign',
}

export function assistantToolLabel(name: string): string {
  const known = TOOL_LABELS[name]
  if (known) return known
  const words = name
    .replace(/^(get|search|list|propose|render|recommend|find|decode)/, '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim()
  if (!words) return name
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export function AssistantToolStatus({ steps }: { steps: AssistantToolStep[] }) {
  return (
    <Stack spacing={0.25} aria-live='polite'>
      {steps.map(step => (
        <Box key={step.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {step.phase === 'done' ? (
            <Check sx={{ fontSize: 14, color: 'text.secondary' }} />
          ) : (
            <CircularProgress size={14} />
          )}
          <Typography variant='caption' color='text.secondary'>
            {assistantToolLabel(step.name)}
          </Typography>
        </Box>
      ))}
    </Stack>
  )
}
